import React, {Fragment, useEffect, useState} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {AddressFormatter, CurrencyFormatter} from "../../../utils/formatters";
import ComponentConfig from "../../form/ComponentConfig";
import InvoiceList from "../lists/invoiceList";
import Button from "../../form/Button";
import {get, set} from "../../../utils/dotutils";
import Modal from "../../layout/Modal";
import {loadComponent} from "../../../utils/components";

const Transaction = (props) => {
    const [opened, setOpened] = useState(false);
    const transaction = get(props, "values.transaction.id") || props.values.transaction || null;
    const [selection, setSelection] = useState(transaction);
    const [invoices, setInvoices] = useState(null);
    let loadRequest;
    useEffect(() => {
        setSelection(transaction);
        loadRequest && loadRequest.abort();
        setInvoices(null);
        if (transaction) {
            loadRequest = loadComponent("componentlist", {
                component: "invoice",
                filter: [{
                    field: "transaction",
                    value: transaction,
                    operator: "="
                }, {
                    field: "billnum",
                    operator: "not isnull"
                }, {
                    field: "billnum",
                    value: "",
                    operator: "!="
                }],
                view: {partner_name: "", partner_address: "", billnum: "", totalprice: "", transaction: {total: ""}},
                order: ["invoice_id"]
            });
            loadRequest.then((data) => {
                setInvoices(data.items || []);
            });
        }
    }, [transaction]);
    return <div className="form-group">
        <label className="control-label">Tranzakció</label>
        <div className="input-group">
            {transaction ? (invoices !== null ? <div className="form-control">
                <b>{invoices[0].partner_name}</b>
                <i> ({AddressFormatter(invoices[0].partner_address)}) </i>
                {
                    invoices.length > 1 ? invoices.map((row) => {
                        return <Fragment><b>{row.billnum}</b> <i>({CurrencyFormatter(row.totalprice).props.children})</i></Fragment>;
                    }).reduce((prev, curr) => [prev, ', ', curr]) : <b>{invoices[0].billnum}</b>
                }
                <b><i> ({CurrencyFormatter(invoices[0].transaction.total).props.children}) </i></b>
                <div className="clearfix"/>
            </div> : <div className="form-control">...</div>) : <div className="form-control" />}
            <div className="input-group-btn">
                <Button color="primary" disabled={props.values[props.componentConfig.idfield]} icon={{lib: "fa", name: "search"}} onClick={() => {
                    setOpened(true);
                }} />
            </div>
        </div>
        <Modal
            header="Kiválasztás"
            size="large"
            state={opened}
            buttons={[
                {
                    text: "Mehet",
                    props: {color: "primary", className: "pull-right", disabled: !transaction === selection},
                    onClick: async () => {
                        props.setFieldValue("transaction", selection);
                        setOpened(false);
                    }
                }, {
                    text: "Mégse",
                    props: {color: "default"},
                    className: "pull-right",
                    onClose: true,
                    onClick: async () => {
                        setSelection(transaction);
                        setOpened(false);
                    }
                }
            ]}
        >
            <ComponentConfig componentName="invoice">
                <InvoiceList
                    ref={(el) => this.list = el}
                    {...props}
                    listFilter={[{
                        field: "transaction.balance",
                        value: 0,
                        operator: "!="
                    },{
                        field: "billnum",
                        operator: "not isnull"
                    },{
                        field: "billnum",
                        value: "",
                        operator: "!="
                    }]}
                    selection={(rows) => rows.find((row) => row.client_component_id + "" === "" + selection)}
                    loadForm={(data) => setSelection(data ? data.client_component_id : null)}
                />
            </ComponentConfig>
        </Modal>
    </div>;
}

class PaymentWriteOffForm extends React.Component {

    render() {
        const props = this.props;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Transaction {...props} />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4 currency">
                        {!this.props.values[this.props.componentConfig.idfield] ? <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="amount"
                            values={this.props.values}
                            formatter={CurrencyFormatter}
                            setFieldValue={this.props.setFieldValue}
                            label="Összeg"
                        /> : <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="total"
                            values={this.props.values}
                            formatter={CurrencyFormatter}
                            setFieldValue={this.props.setFieldValue}
                            label="Összeg"
                        />}
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(PaymentWriteOffForm);
